<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100"
      >
        <div class="md-layout">
          <div class="md-card md-theme-default">
            <div class="md-card-header">
              <h4 class="title">
                Toolset
              </h4>
              <md-button @click="validate_forms">SAVE </md-button>
            </div>

            <div class="md-card-content">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="get_validation_class('form', 'etag')">
                    <label for="last-name">E-tag</label>
                    <md-input
                      name="etag"
                      id="etag"
                      autocomplete="etag"
                      v-model="form.etag"
                      :disabled="disabledEtag"
                    />
                    <span class="md-error" v-if="!$v.form.etag.required"
                      >The E-tag is required</span
                    >
                    <span class="md-error" v-else-if="!$v.form.etag.minlength"
                      >Invalid E-tag</span
                    >
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="get_validation_class('form', 'address')">
                    <label for="last-name">Address</label>
                    <md-input
                      name="address"
                      id="address"
                      autocomplete="address"
                      v-model="form.address"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.address.required"
                      >The address is required</span
                    >
                    <span
                      class="md-error"
                      v-else-if="!$v.form.address.minlength"
                      >Invalid address</span
                    >
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="get_validation_class('form', 'type')">
                    <label for="last-name">Type</label>
                    <md-input
                      name="type"
                      id="type"
                      autocomplete="type"
                      v-model="form.type"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.type.required"
                      >The type is required</span
                    >
                    <span class="md-error" v-else-if="!$v.form.type.minlength"
                      >Invalid type</span
                    >
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="get_validation_class('form', 'version')">
                    <label for="last-name">Version</label>
                    <md-input
                      name="version"
                      id="version"
                      autocomplete="version"
                      v-model="form.version"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.version.required"
                      >The version is required</span
                    >
                    <span
                      class="md-error"
                      v-else-if="!$v.form.version.minlength"
                      >Invalid version</span
                    >
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="get_validation_class('form', 'fpga')">
                    <label for="last-name">FPGA firmware</label>
                    <md-input
                      name="fpga"
                      id="fpga"
                      autocomplete="fpga"
                      v-model="form.fpga"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.fpga.required"
                      >The FPGA firmware is required</span
                    >
                    <span class="md-error" v-else-if="!$v.form.fpga.minlength"
                      >Invalid FPGA firmware</span
                    >
                  </md-field>
                  <md-list class="md-dense">
                    <md-list-item
                      v-for="firmware in fpgaHistory"
                      v-bind:key="firmware.date"
                    >
                      <span class="md-list-item-text"
                        >{{ firmware.date }}: {{ firmware.firmware }}</span
                      >
                    </md-list-item>
                  </md-list>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="get_validation_class('form', 'fx3')">
                    <label for="last-name">FX3 firmware</label>
                    <md-input
                      name="fx3"
                      id="fx3"
                      autocomplete="fx3"
                      v-model="form.fx3"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.fx3.required"
                      >The FX3 firmware is required</span
                    >
                    <span class="md-error" v-else-if="!$v.form.fx3.minlength"
                      >Invalid FX3 firmware</span
                    >
                  </md-field>
                  <md-list class="md-dense">
                    <md-list-item
                      v-for="firmware in fx3History"
                      v-bind:key="firmware.date"
                    >
                      <span class="md-list-item-text"
                        >{{ firmware.date }}: {{ firmware.firmware }}</span
                      >
                    </md-list-item>
                  </md-list>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="get_validation_class('form', 'comment')">
                    <label for="last-name">Comment</label>
                    <md-textarea
                      name="comment"
                      id="comment"
                      autocomplete="comment"
                      v-model="form.comment"
                      :disabled="sending"
                    >
                    </md-textarea>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-table v-model="peripherals" md-card>
                    <md-table-toolbar>
                      <h1 class="md-title">Peripherals</h1>
                      <md-button
                        class="md-icon-button md-danger"
                        @click="add_peripheral"
                      >
                        <md-icon>add</md-icon>
                      </md-button>
                      <md-button
                        class="md-icon-button md-danger"
                        @click="delete_peripheral"
                      >
                        <md-icon>delete</md-icon>
                      </md-button>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="E-tag" md-sort-by="id"
                        ><md-field>
                          <label for="perietag">E-tag</label>
                          <md-input
                            name="perietag"
                            id="perietag"
                            autocomplete="perietag"
                            v-model="item.etag"
                            :disabled="disabledPeripheral(item.etag)"
                          /> </md-field
                      ></md-table-cell>
                      <md-table-cell md-label="Type" md-sort-by="type"
                        ><md-field>
                          <label for="perietype">Type</label>
                          <md-select
                            name="perietype"
                            id="perietype"
                            autocomplete="perietype"
                            v-model="item.type"
                            :disabled="sending"
                          >
                            <md-option value="1.0 Mhz">1.0 Mhz</md-option>
                            <md-option value="1.5 Mhz">1.5 Mhz</md-option>
                            <md-option value="2.25 Mhz">2.25 Mhz</md-option>
                            <md-option value="4.0 Mhz">4.0 Mhz</md-option>
                          </md-select></md-field
                        ></md-table-cell
                      >
                      <md-table-cell md-label="Version" md-sort-by="version"
                        ><md-field>
                          <label for="perietype">Version</label>
                          <md-select
                            name="perieversion"
                            id="perieversion"
                            autocomplete="perieversion"
                            v-model="item.version"
                            :disabled="sending"
                          >
                            <md-option value="V1.0">V1.0</md-option>
                            <md-option value="V2.0">V2.0</md-option>
                          </md-select></md-field
                        ></md-table-cell
                      >
                      <md-table-cell
                        md-label="Firmware"
                        md-sort-by="pipescannerFirmwareVersion"
                        ><md-field>
                          <label for="periepipescannerFirmwareVersion"
                            >Firmware</label
                          >
                          <md-input
                            name="periepipescannerFirmwareVersion"
                            id="periepipescannerFirmwareVersion"
                            autocomplete="periepipescannerFirmwareVersion"
                            v-model="item.pipescannerFirmwareVersion"
                            :disabled="sending"
                          /> </md-field
                      ></md-table-cell>
                      <md-table-cell
                        md-label="UT Serial"
                        md-sort-by="pipescannerFirmwareVersion"
                        ><md-field>
                          <label for="utserial">UT Serial</label>
                          <md-input
                            name="utserial"
                            id="utserial"
                            autocomplete="utserial"
                            v-model="item.utSerial"
                            :disabled="sending"
                          /> </md-field
                      ></md-table-cell>
                      <md-table-cell md-label="IMU Version" md-sort-by="imu"
                        ><md-field>
                          <label for="imuVersion">IMU Version</label>

                          <md-select
                            name="imuVersion"
                            id="imuVersion"
                            v-model="item.imuVersion"
                            :disabled="sending"
                          >
                            <md-option value="BNO055">BNO055</md-option>
                            <md-option value="BNO080">BNO080</md-option>
                          </md-select>
                        </md-field>
                      </md-table-cell>
                      <md-table-cell
                        md-label="Handheld Chip"
                        md-sort-by="handheldChip"
                        ><md-field>
                          <label for="handheldChip">Handheld Chip</label>
                          <md-select
                            name="handheldChip"
                            id="handheldChip"
                            v-model="item.handheldChip"
                            :disabled="sending"
                          >
                            <md-option value="ATSAMD21G18A-MU"
                              >ATSAMD21G18A-MU</md-option
                            >
                            <md-option value="ATSAMD21G17A-MU"
                              >ATSAMD21G17A-MU</md-option
                            >
                          </md-select>
                        </md-field>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { mapState, mapMutations } from "vuex";
import axios from "axios";

export default {
  mixins: [validationMixin],
  beforeCreate() {},
  components: {},
  data() {
    return {
      beforeEdit: {},
      fpgaHistory: [],
      fx3History: [],
      peripherals: [],
      form: {
        etag: null,
        address: null,
        fx3: null,
        fpga: null,
        comment: null,
        version: null,
        type: null,
      },
      userSaved: false,
      sending: false,
      lastUser: null,
    };
  },
  validations: {
    form: {
      etag: {
        required,
        minLength: minLength(3),
      },
      address: {
        required,
        minLength: minLength(3),
      },
      fx3: {
        required,
        minLength: minLength(3),
      },
      fpga: {
        required,
        minLength: minLength(3),
      },
      version: {
        required,
        minLength: minLength(3),
      },
      type: {
        required,
        minLength: minLength(3),
      },
    },
  },
  mounted() {
    if (!this.groupServices.includes("pipescanner-inspections")) {
      this.$router.push("/");
    } else {
      this.beforeEdit = JSON.parse(JSON.stringify(this.editTool));
      this.set_peripherals(this.editTool);
      this.set_datalogger(this.editTool);
    }
  },
  computed: {
    ...mapState([
      "apiEndpoints",
      "groupServices",
      "groupSelected",
      "editTool",
      "permissions",
    ]),
    /**
     * Computed property using both forms
     * @return {object} object with the registration form in the right format.
     */
    toolRegistrationForm() {
      var ts = Math.floor(new Date().getTime() / 1000);
      var registrationForm = {};
      registrationForm["id"] = this.form.etag;
      registrationForm["type"] = this.form.type;
      registrationForm["version"] = this.form.version;
      registrationForm["group"] = this.groupSelected;
      registrationForm["address"] = this.form.address;
      registrationForm["comment"] = this.form.comment;
      const avoidClone = JSON.parse(JSON.stringify(this.editTool));
      registrationForm["firmwareHistory"] = avoidClone.firmwareHistory;
      if (
        !this.beforeEdit.firmwareHistory
          .map((x) => x.fpgaFirmwareVersion)
          .includes(this.form.fpga) ||
        !this.beforeEdit.firmwareHistory
          .map((x) => x.fx3FirmwareVersion)
          .includes(this.form.fx3)
      ) {
        registrationForm["firmwareHistory"].push({
          timestamp: ts,
          fx3FirmwareVersion: this.form.fx3,
          fpgaFirmwareVersion: this.form.fpga,
        });
      }
      var peripherals = {};
      this.peripherals.map((item) => {
        peripherals[item.etag] = {
          type: item.type,
          version: item.version,
          handheldChip: item.handheldChip,
          imuVersion: item.imuVersion,
          utSerial: item.utSerial,
        };

        if (!Object.keys(avoidClone.peripherals).includes(item.etag)) {
          peripherals[item.etag] = {
            type: item.type,
            version: item.version,
            firmwareHistory: [
              {
                timestamp: ts,
                pipescannerFirmwareVersion: item.pipescannerFirmwareVersion,
              },
            ],
          };
        } else {
          peripherals[item.etag]["firmwareHistory"] =
            avoidClone.peripherals[item.etag].firmwareHistory;
        }

        if (
          !peripherals[item.etag].firmwareHistory
            .map((x) => x.pipescannerFirmwareVersion)
            .includes(item.pipescannerFirmwareVersion)
        ) {
          peripherals[item.etag].firmwareHistory.push({
            timestamp: ts,
            pipescannerFirmwareVersion: item.pipescannerFirmwareVersion,
          });
        }
      });
      registrationForm["peripherals"] = peripherals;

      return registrationForm;
    },
    /**
     * Preserve etag of datalogger
     * @return {Boolean} boolean to diasable
     */
    disabledEtag() {
      return true;
    },
  },
  watch: {
    /**
     * watcher to check the validity of route compared to services of group
     * @param {Array} newVal - New value of group services
     */
    groupServices(newVal) {
      if (!newVal.includes("pipescanner-inspections")) {
        this.$router.push("/");
      }
    },
  },
  methods: {
    /**
     * Preserve existing peripheral etags and allow edit on new ones
     * @param {string} etag - etag of the perihperal which is already there (don't change the etag)
     * @return {Boolean} boolean to diasable or not disable
     */
    disabledPeripheral(etag) {
      if (Object.keys(this.beforeEdit.peripherals).includes(etag)) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Sets perihperals for GUI (form)
     * @param {Object} toolObject - Object of toolset
     */
    set_peripherals(toolObject) {
      if (Object.keys(toolObject.peripherals).length > 0) {
        Object.keys(toolObject.peripherals).forEach((entry) => {
          var peripheral = {
            etag: entry,
            type: toolObject.peripherals[entry].type,
            version: toolObject.peripherals[entry].version,
            handheldChip: toolObject.peripherals[entry].handheldChip,
            imuVersion: toolObject.peripherals[entry].imuVersion,
            utSerial: toolObject.peripherals[entry].utSerial,
            pipescannerFirmwareVersion:
              toolObject.peripherals[entry].firmwareHistory[
                toolObject.peripherals[entry].firmwareHistory.length - 1
              ].pipescannerFirmwareVersion,
          };
          this.peripherals.push(peripheral);
        });
      }
    },
    /**
     * Sets datalogeer for GUI (form)
     * @param {Object} toolObject - Object of toolset
     */
    set_datalogger(toolObject) {
      var datalogger = {
        etag: toolObject.id,
        address: toolObject.address,
        fx3:
          toolObject.firmwareHistory[toolObject.firmwareHistory.length - 1]
            .fx3FirmwareVersion,
        fpga:
          toolObject.firmwareHistory[toolObject.firmwareHistory.length - 1]
            .fpgaFirmwareVersion,
        comment: toolObject.comment,
        version: toolObject.version,
        type: toolObject.type,
      };
      this.fpgaHistory = toolObject.firmwareHistory.map((x) => {
        var date = new Date(x.timestamp * 1000);
        var dateString =
          date.getDay() + "-" + date.getMonth() + "-" + date.getFullYear();
        var firmware = {
          date: dateString,
          firmware: x.fpgaFirmwareVersion,
        };
        return firmware;
      });
      this.fx3History = toolObject.firmwareHistory.map((x) => {
        var date = new Date(x.timestamp * 1000);
        var dateString =
          date.getDay() + "-" + date.getMonth() + "-" + date.getFullYear();
        var firmware = {
          date: dateString,
          firmware: x.fx3FirmwareVersion,
        };
        return firmware;
      });
      this.form = JSON.parse(JSON.stringify(datalogger));
    },
    /**
     * Removes last peripheral.
     */
    delete_peripheral() {
      this.peripherals.pop();
    },
    /**
     * Adds new peripheral
     */
    add_peripheral() {
      this.peripherals.push({
        etag: null,
        type: null,
        version: null,
        pipescannerFirmwareVersion: null,
        handheldChip: null,
        imuVersion: null,
        utSerial: null,
      });
    },
    /**
     * Handle validation of the form fields.
     * @param {string} form - name of the form class
     * @param {string} fieldName - name of the field
     * @return {string} string with class name.
     */
    get_validation_class(form, fieldName) {
      const field = this.$v[form][fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    /**
     * Runs the form validation
     */
    async validate_forms() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = await this.$auth.getTokenSilently();

        var header = {
          headers: {
            Authorization: "Bearer " + token,
          },
        };

        var objectDiffs = this.difference(
          this.toolRegistrationForm,
          this.beforeEdit
        );
        var updateKeys = Object.keys(objectDiffs);
        var dataloggerFirmwareUpdate = null;

        if (updateKeys.includes("firmwareHistory")) {
          dataloggerFirmwareUpdate = this._.differenceWith(
            this.toolRegistrationForm.firmwareHistory,
            this.beforeEdit.firmwareHistory,
            this._.isEqual
          )[0];
          delete dataloggerFirmwareUpdate.timestamp;
          delete objectDiffs.firmwareHistory;
        }

        if (updateKeys.includes("peripherals")) {
          var editPeripherals = this.toolRegistrationForm.peripherals;
          objectDiffs.peripherals = editPeripherals;
        }

        if (Object.keys(objectDiffs).length > 0) {
          //post request to edit-tool
          var endpoint =
            this.apiEndpoints.base +
            this.apiEndpoints.tools.editTool +
            this.toolRegistrationForm.id;
          axios
            .post(endpoint, objectDiffs, header)
            .then((response) => {
              this.$notify({
                message: "Toolset saved",
                icon: "check",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
              });
              this.$router.push("/tools");
            })
            .catch((error) => {
              this.$notify({
                message: error,
                icon: "check",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger",
              });
            });
        }

        if (dataloggerFirmwareUpdate) {
          //post request to register firmware
          var endpoint =
            this.apiEndpoints.base +
            this.apiEndpoints.tools.registerFirmware +
            this.toolRegistrationForm.id;
          axios
            .post(endpoint, dataloggerFirmwareUpdate, header)
            .then((response) => {
              this.$notify({
                message: "Toolset saved",
                icon: "check",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
              });
              this.$router.push("/tools");
            })
            .catch((error) => {
              this.$notify({
                message: error,
                icon: "check",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger",
              });
            });
        }
      }
    },
    /**
     * isolate the difference between two object.
     * @param {obj} object - latest version of the object
     * @param {obj} base - base object you want to compare with
     * @return {obj} object with the differences between object and base.
     */
    difference(object, base) {
      return this._.transform(object, (result, value, key) => {
        if (!this._.isEqual(value, base[key])) {
          result[key] =
            this._.isObject(value) && this._.isObject(base[key])
              ? this.difference(value, base[key])
              : value;
        }
      });
    },
  },
};
</script>
